module.exports = __webpack_public_path__ + "media/images/confetti-cc46362aea27b6fa0dacadea01f18c26.svg";